import Box from "@mui/joy/Box";
import CircularProgress from "@mui/joy/CircularProgress";
import zIndex from "@mui/material/styles/zIndex";

export interface LoaderProps {
  isLoading?: boolean
}

export function Loader(props: LoaderProps) {
  const { isLoading = true } = props;
  return isLoading ? (
    <Box style={loadingContainerStyle}>
      <CircularProgress size="lg" />
    </Box>
  ) : <></>;
}

export const loadingContainerStyle = {
  backgroundColor: "white",
  display: "flex",
  height: "100vh",
  justifyContent: "center",
  opacity: "50%",
  paddingTop: "10rem",
  position: "absolute" as const,
  top: 0,
  width: "100vw",
  zIndex: zIndex.modal + 1,
};
